import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const latitudeField: number = 0
const longitudeField: number = 0

export default function TopFilter (props: any) {
  const { defaultMarks } = props
  const [latitudeHere, setLatitudeHere] = useState(latitudeField)
  const [longitudeHere, setLongitudeHere] = useState(longitudeField)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const handleClick = (locationDistance: number) => {
    setIsLoading(true)
    const interval = setInterval(() => {
      if (!latitudeHere || !longitudeHere) return
      history.push(`/search_result?lat=${latitudeHere}&long=${longitudeHere}&locationDistance=${locationDistance}`)
      clearInterval(interval)
    }, 200)
  }

  const handleClickMark = (markId: string) => {
    setIsLoading(true)
    const interval = setInterval(() => {
      if (!markId) return
      history.push(`/search_result?markId=${markId}`)
      clearInterval(interval)
    }, 200)
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position: any) => {
      setLatitudeHere(position.coords && position.coords.latitude)
      setLongitudeHere(position.coords && position.coords.longitude)
    })
  }, [isLoading])

  return (
    <div className="find-shop-near">
      <h2 className="title">
        <i className="bi bi-geo-alt-fill" /> 近くの店舗を探す
      </h2>
      <div className="mt-3">
        <button
          type="button"
          className="btn btn-lg btn-outline-secondary me-2"
          onClick={() => handleClick(300)}
        >
          300m
        </button>
        <button
          type="button"
          className="btn btn-lg btn-outline-secondary me-2"
          onClick={() => handleClick(500)}
        >
          500m
        </button>
        <button
          type="button"
          className="btn btn-lg btn-outline-secondary me-2"
          onClick={() => handleClick(1000)}
        >
          1km
        </button>
        <button
          type="button"
          className="btn btn-lg btn-outline-green me-2"
          onClick={() => handleClickMark(defaultMarks && defaultMarks.length && defaultMarks[0].id)}
        >
          <i className="bi bi-megaphone-fill" /> 応援動画歓迎店
        </button>
        <button
          type="button"
          className="btn btn-lg btn-outline-red"
          onClick={() => handleClickMark(defaultMarks && defaultMarks.length && defaultMarks[1].id)}
        >
          <i className="bi bi-heart-fill" /> 子供連れにオススメ
        </button>
      </div>
    </div>
  )
}
